(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["confidis-shopify-form"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__confidisShopifyForm) return;
    window.__confidisShopifyForm = true;

    const postedRe = /(?:customer|contact)_posted=true/;
    const nativeSubmit = HTMLFormElement.prototype.submit;

    const wrapOf = (form) => form.closest('[data-confidis-shopify-form]');

    const stripActionHash = (form) => {
      const action = form.getAttribute('action');
      if (action && action.includes('#')) form.setAttribute('action', action.split('#')[0]);
    };

    const setLoading = (form, loading) => {
      const button = form.querySelector('button[type="submit"]');
      if (!button) return;
      button.disabled = loading;
      button.classList.toggle('is-loading', loading);
      if (loading) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
      const spinner = button.querySelector('.confidis-btn__spinner');
      if (spinner) spinner.hidden = !loading;
    };

    const showError = (form, message) => {
      form.querySelectorAll('[data-confidis-form-error]').forEach((el) => el.remove());
      const error = document.createElement('p');
      error.dataset.confidisFormError = '';
      error.className = 'errors';
      error.textContent = message;
      form.prepend(error);
    };

    const postForm = async (form) => {
      const wrap = wrapOf(form);
      if (!wrap) return;

      const successMessage = wrap.getAttribute('data-success') || 'Thank you!';
      const statusClass = wrap.getAttribute('data-status-class') || 'confidis-home__status';
      let keepLoading = false;

      form.querySelectorAll('[data-confidis-form-error]').forEach((el) => el.remove());
      setLoading(form, true);

      if (form._confidisAbort) form._confidisAbort.abort();
      form._confidisAbort = new AbortController();

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: form._confidisAbort.signal,
        });
        const html = await response.text();
        const url = response.url || '';

        if (url.includes('/challenge')) {
          keepLoading = true;
          window.location.assign(url);
          return;
        }

        if (/missing captcha token|invalid captcha token/i.test(html)) {
          showError(form, 'Could not verify this submission. Please try again.');
          return;
        }

        if (postedRe.test(url)) {
          const status = document.createElement('p');
          status.className = statusClass;
          status.setAttribute('role', 'status');
          status.textContent = successMessage;
          form.replaceChildren(status);
          return;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const remoteForm = form.id ? doc.getElementById(form.id) : null;
        const errorRoot = remoteForm?.querySelector('.errors') || doc.querySelector('.errors');
        showError(form, errorRoot?.textContent?.trim() || 'Could not submit. Please try again.');
      } catch (error) {
        if (error?.name === 'AbortError') {
          keepLoading = true;
          return;
        }
        showError(form, 'Could not submit. Please try again.');
      } finally {
        if (!keepLoading) setLoading(form, false);
      }
    };

    HTMLFormElement.prototype.submit = function () {
      if (wrapOf(this)) {
        postForm(this);
        return;
      }
      return nativeSubmit.call(this);
    };

    const rebindCaptcha = (form) => {
      const bind = window.Shopify?.ce_forms?.bindForm;
      const siteKey = form.querySelector('[data-sitekey]')?.getAttribute('data-sitekey');
      if (typeof bind !== 'function' || !siteKey) return false;
      const clone = form.cloneNode(true);
      clone.removeAttribute('data-hcaptcha-bound');
      clone.querySelectorAll('.h-captcha').forEach((el) => el.remove());
      form.replaceWith(clone);
      bind(clone, siteKey);
      return true;
    };

    document.querySelectorAll('[data-confidis-shopify-form] form').forEach((form) => {
      stripActionHash(form);
      if (rebindCaptcha(form)) return;
      const wrap = wrapOf(form);
      if (!wrap) return;
      const observer = new MutationObserver(() => {
        const live = wrap.querySelector('form');
        if (live && rebindCaptcha(live)) observer.disconnect();
      });
      observer.observe(wrap, { childList: true, subtree: true, attributes: true });
    });

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !wrapOf(form)) return;
        setLoading(form, true);
      },
      true
    );

    if (postedRe.test(window.location.search)) {
      const status = document.querySelector('.confidis-home__status, .confidis-contact__status');
      if (status) status.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
